import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/Layout"

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>About our workshop | Service Center</title>
        <meta
          name="description"
          content="We service & repair all types of small petrol engines: lawnmowers, chainsaws, water blasters, compressors, leaf blowers, generators, and trimmers"
        />
        <meta
          property="og:image"
          content="https://servicecentre.co.nz/app/uploads/service-centre-building.jpg"
        />
        <meta
          property="og:image:alt"
          content="Mitre 10 Mega Masterton Service Centre"
        />
      </Helmet>

      <Layout hidePageHeader={true}>
        <section className="page-section container">
          <h1 className="mb-5">Not Found</h1>
          <div class="alert alert-warning">
            Sorry, but the page you were trying to view does not exist.
          </div>
        </section>
      </Layout>
    </>
  )
}
